// Fatia S1: entrar com e-mail e senha (ou Google); trata 2º fator pendente.
import { useState, type FormEvent } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import type { AuthProvidersResponse, LoginResponse } from '@impulso/shared/api/identity'
import { api, errorMessage } from '../../lib/api'
import { useSession } from '../../lib/session'
import AuthShell, { FormError } from '../../features/auth/AuthShell'
import PasswordInput from '../../features/auth/PasswordInput'
import { LOGIN_ERRORS, safeNext } from '../../features/auth/session-helpers'

export default function Login() {
  const [params] = useSearchParams()
  const next = safeNext(params.get('next'))
  const navigate = useNavigate()
  const { refresh } = useSession()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(LOGIN_ERRORS[params.get('erro') ?? ''] ?? null)
  const [busy, setBusy] = useState(false)
  const providers = useQuery({ queryKey: ['auth-providers'], queryFn: () => api.get<AuthProvidersResponse>('/auth/providers'), staleTime: 300_000 })

  async function submit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      const r = await api.post<LoginResponse>('/auth/login', { email, password })
      await refresh()
      navigate(r.pending2fa ? `/2fa?next=${encodeURIComponent(next)}` : next, { replace: true })
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthShell title="Entrar" sub="Que bom te ver de novo." footer={<>Ainda não tem conta? <Link className="strong auth-hit" style={{ color: 'var(--primary)' }} to="/cadastro">Teste grátis por 14 dias</Link></>}>
      <form className="stack" style={{ gap: 14 }} onSubmit={submit}>
        <FormError error={error} />
        <div className="field">
          <label htmlFor="email">E-mail</label>
          <input id="email" className="input" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="field">
          <div className="row between"><label htmlFor="password">Senha</label><Link className="small auth-hit" style={{ color: 'var(--primary)' }} to="/recuperar-senha">Esqueci a senha</Link></div>
          <PasswordInput id="password" value={password} onChange={setPassword} autoComplete="current-password" required />
        </div>
        <button type="submit" className="btn primary lg block" disabled={busy}>{busy ? 'Entrando…' : 'Entrar'}</button>
        {providers.data?.google && (
          <>
            <div className="row small muted" style={{ gap: 8 }}><div className="divider" style={{ flex: 1, margin: 0 }} />ou<div className="divider" style={{ flex: 1, margin: 0 }} /></div>
            <a className="btn block" href={`/api/v1/auth/google/start?next=${encodeURIComponent(next)}`}>
              <span className="pf-logo pf-google">G</span> Entrar com o Google
            </a>
          </>
        )}
      </form>
    </AuthShell>
  )
}
